// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-trend-up';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.424 9.504v-5.04h-5.04' />
    <path d='m17.424 4.464-5.976 5.976a1.13 1.13 0 0 1-1.584 0L7.488 8.064a1.13 1.13 0 0 0-1.584 0l-5.4 5.4' />
  </g>
);

export const viewBox = '0 0 18 18';
